module.exports = __webpack_public_path__ + "img/pies.5da744c0.svg";